import React from "react";
import { Row, Col, Container } from "reactstrap";

const Footer = () => {
  return <React.Fragment></React.Fragment>;
};

export default Footer;
